import ContainerSimple from "../../../Components/ContainerSimple";
import InputAdmin from "../../../Components/InputFields/InputAdmin";
import Custom from "../../../Components/Buttons/Custom";
import { useState, useEffect } from "react";
import { API_BASE_URL } from "../../../config/api";
import { ErrorState, Spinner } from "../../../Components/AsyncState";

export default function KYCModal({ onClose, selectedUserId }) {
  const [reason, setReason] = useState("");
  const [notes, setNotes] = useState("");
  const handleDownload = (fileUrl) => {
    if (!fileUrl) return;

    const link = document.createElement("a");
    link.href = fileUrl;
    link.download = ""; // let browser infer filename
    link.target = "_blank"; // fallback for PDFs
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const [kycData, setKycData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const fetchKycData = async () => {
    setLoading(true); setError("");
    try {
      let response = await fetch(
        `${API_BASE_URL}/api/v0/auth/admin/users/${selectedUserId}/kyc/pending/`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access")}`,
          },
        },
      );

      // If access token is invalid/expired → try refresh
      if (response.status === 401) {
        const refreshResponse = await fetch(
          `${API_BASE_URL}/api/v0/auth/admin/jwt/refresh/`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              refresh: localStorage.getItem("refresh"),
            }),
          },
        );

        if (!refreshResponse.ok) {
          // refresh failed → logout
          localStorage.removeItem("access");
          localStorage.removeItem("authCredentials");
          localStorage.removeItem("refresh");
          localStorage.removeItem("role");
          localStorage.removeItem("email");
          window.location.href = "/signin";
          return; // ⬅️ IMPORTANT
        }

        const refreshData = await refreshResponse.json();
        localStorage.setItem("access", refreshData.access);

        // retry original request with new access token
        response = await fetch(
          `${API_BASE_URL}/api/v0/auth/admin/users/${selectedUserId}/kyc/pending/`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("access")}`,
            },
          },
        );
      }

      // Now handle final response (either first or retried)
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Account Data:", data);
      setKycData(data);
    } catch (error) {
      console.error("Error fetching account data:", error);
      setError("خطا در دریافت اطلاعات احراز هویت");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchKycData();
  }, []);
  const handleApprove = async () => {
    if (reason !== "" || notes !== "") {
      return;
    }
    try {
      let response = await fetch(
        `${API_BASE_URL}/api/v0/auth/admin/users/${selectedUserId}/kyc/pending/approve/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access")}`,
          },
        },
      );

      // If access token is invalid/expired → try refresh
      if (response.status === 401) {
        const refreshResponse = await fetch(
          `${API_BASE_URL}/api/v0/auth/admin/jwt/refresh/`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              refresh: localStorage.getItem("refresh"),
            }),
          },
        );

        if (!refreshResponse.ok) {
          // refresh failed → logout
          localStorage.removeItem("access");
          localStorage.removeItem("authCredentials");
          localStorage.removeItem("refresh");
          localStorage.removeItem("role");
          localStorage.removeItem("email");
          window.location.href = "/signin";
          return; // ⬅️ IMPORTANT
        }

        const refreshData = await refreshResponse.json();
        localStorage.setItem("access", refreshData.access);

        // retry original request with new access token
        response = await fetch(
          `${API_BASE_URL}/api/v0/auth/admin/users/${selectedUserId}/kyc/pending/approve/`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("access")}`,
            },
          },
        );
      }

      // Now handle final response (either first or retried)
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      onClose();
      window.location.reload();
    } catch (error) {
      console.error("Error fetching account data:", error);
    }
  };
  const handleReject = async () => {
    if (!reason || !notes) {
      return;
    }
    const jsonBody = {
      reason_failed: reason,
      description: notes,
    };
    try {
      let response = await fetch(
        `${API_BASE_URL}/api/v0/auth/admin/users/${selectedUserId}/kyc/pending/reject/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access")}`,
          },
          body: JSON.stringify(jsonBody),
        },
      );

      // If access token is invalid/expired → try refresh
      if (response.status === 401) {
        const refreshResponse = await fetch(
          `${API_BASE_URL}/api/v0/auth/admin/jwt/refresh/`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              refresh: localStorage.getItem("refresh"),
            }),
          },
        );

        if (!refreshResponse.ok) {
          // refresh failed → logout
          localStorage.removeItem("access");
          localStorage.removeItem("authCredentials");
          localStorage.removeItem("refresh");
          localStorage.removeItem("role");
          localStorage.removeItem("email");
          window.location.href = "/signin";
          return; // ⬅️ IMPORTANT
        }

        const refreshData = await refreshResponse.json();
        localStorage.setItem("access", refreshData.access);

        // retry original request with new access token
        response = await fetch(
          `${API_BASE_URL}/api/v0/auth/admin/users/${selectedUserId}/kyc/pending/reject/`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("access")}`,
            },
            body: JSON.stringify(jsonBody),
          },
        );
      }

      // Now handle final response (either first or retried)
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      onClose();
      window.location.reload();
    } catch (error) {
      console.error("Error fetching account data:", error);
    }
  };
  const identityUrl =
    kycData?.find((doc) => doc.kyc_type_name === "identity")?.documents?.[0]
      ?.document_file || "";
  const isIdentityPdf = identityUrl.toLowerCase().endsWith(".pdf");

  const selfieUrl =
    kycData?.find((doc) => doc.kyc_type_name === "identity_with_selfie")
      ?.documents?.[0]?.document_file || "";
  const isSelfiePdf = selfieUrl.toLowerCase().endsWith(".pdf");
  if (loading) return <div role="status" aria-label="در حال بارگذاری" className="flex min-h-72 items-center justify-center text-[#8080804d]"><Spinner /></div>;
  if (error) return <ErrorState message={error} onRetry={fetchKycData} className="min-h-72" />;
  if (!kycData) return <ErrorState message="اطلاعات احراز هویت یافت نشد" className="min-h-72" />;

  return (
    <ContainerSimple>
      <div className="w-full flex divide-x divide-x-reverse divide-zi-border-light dark:divide-zi-border-dark">
        <div className="w-full pl-5 flex flex-col items-center gap-5">
          <span className="font-medium text-lg text-zi-text-light dark:text-zi-text-dark">
            مدرک شناسایی
          </span>
          <div className="w-full aspect-[9/16] bg-zi-bg1-light dark:bg-zi-bg1-dark">
            {identityUrl ? (
              isIdentityPdf ? (
                <iframe
                  src={identityUrl}
                  title="مدرک شناسایی"
                  className="w-full h-full"
                />
              ) : (
                <img
                  src={identityUrl}
                  alt="مدرک شناسایی"
                  className="w-full h-full object-contain"
                />
              )
            ) : null}
          </div>
          <Custom
            text="دانلود و مشاهده فایل"
            svg_name="download"
            svgClassName="stroke-zi-text-light dark:stroke-zi-text-dark"
            href=""
            onClick={() => handleDownload(identityUrl)}
            className="!rounded-lg !p-2.5 w-full text-zi-text-light dark:text-zi-text-dark bg-zi-bg1-light dark:bg-zi-bg1-dark"
          />
        </div>
        <div className="w-full pr-5 flex flex-col items-center gap-5">
          <span className="font-medium text-lg text-zi-text-light dark:text-zi-text-dark">
            تصویر سلفی
          </span>
          <div className="w-full aspect-[9/16] bg-zi-bg1-light dark:bg-zi-bg1-dark">
            {identityUrl ? (
              isIdentityPdf ? (
                <iframe
                  src={identityUrl}
                  title="مدرک شناسایی"
                  className="w-full h-full"
                />
              ) : (
                <img
                  src={identityUrl}
                  alt="مدرک شناسایی"
                  className="w-full h-full object-contain"
                />
              )
            ) : null}
          </div>
          <Custom
            text="دانلود و مشاهده فایل"
            svg_name="download"
            svgClassName="stroke-zi-text-light dark:stroke-zi-text-dark"
            href=""
            onClick={() => handleDownload(selfieUrl)}
            className="!rounded-lg !p-2.5 w-full text-zi-text-light dark:text-zi-text-dark bg-zi-bg1-light dark:bg-zi-bg1-dark"
          />
        </div>
      </div>
      <div className="w-full flex gap-12">
        <InputAdmin
          onChange={(e) => {
            let actualReason;
            if (e.target.value === "ناواضح بودن تصاویر") {
              actualReason = 1;
            } else if (e.target.value === "مدارک منقضی شده") {
              actualReason = 2;
            } else if (e.target.value === "مدارک نامعتبر") {
              actualReason = 3;
            } else if (e.target.value === "اطلاعات نادرست") {
              actualReason = 4;
            } else if (e.target.value === "دلایل دیگر") {
              actualReason = 6;
            }
            setReason(actualReason);
          }}
          label="علت رد شدن"
          id="reason"
          name="reason"
          type="select"
          selectPlaceHolder="انتخاب کنید"
          selectOptions={[
            "ناواضح بودن تصاویر",
            "مدارک منقضی شده",
            "مدارک نامعتبر",
            "اطلاعات نادرست",
            "دلایل دیگر",
          ]}
        />
        <div className="w-full"></div>
      </div>
      <textarea
        value={notes}
        onChange={(e) => setNotes(e.target.value)}
        id="notes"
        name="notes"
        placeholder="علت رد شدن مدارک آپلود شده را اینجا بنویسید..."
        className="w-full h-40 py-1 px-2.5 leading-loose rounded-lg bg-zi-bg1-light dark:bg-zi-bg1-dark text-zi-text-light dark:text-zi-text-dark resize-none"
      ></textarea>
      <div className="w-full flex gap-2.5 mt-6">
        <Custom
          text="رد احراز هویت"
          svg_name="xMark"
          svgClassName="stroke-zi-text-light dark:stroke-zi-text-dark"
          href=""
          className="!rounded-lg !p-2.5 w-full text-zi-text-light dark:text-zi-text-dark ring-1 ring-zi-border-dark bg-transparent"
          onClick={handleReject}
        />
        <Custom
          text="تأیید احراز هویت"
          svg_name="checkMark"
          svgClassName="stroke-zi-text-dark"
          href=""
          className="!rounded-lg !p-2.5 w-full text-zi-text-dark bg-zi-gradient-button-blue"
          textShadow={true}
          svgShadow={true}
          onClick={handleApprove}
        />
      </div>
    </ContainerSimple>
  );
}
